/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PhotoDetails_photoQuery = {
    readonly projectName: string | null;
    readonly projectUrl: string | null;
    readonly " $refType": "PhotoDetails_photoQuery";
};
export type PhotoDetails_photoQuery$data = PhotoDetails_photoQuery;
export type PhotoDetails_photoQuery$key = {
    readonly " $data"?: PhotoDetails_photoQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"PhotoDetails_photoQuery">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PhotoDetails_photoQuery",
  "type": "TradePhotosQueryOutput",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "projectName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "projectUrl",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'd8c1d4e58f56da1d013063015d5f36b8';
export default node;
